<template>
    <div>
        <PageTitle :title="$t('gracias.title')" sectionClass="buy_success" />
        <FirstBanner />

        <section class="padding-vertical-content pt-0">
            <b-container>
                <ContentOrLoading :class="loading ? 'p-5' : ''">
                    <b-row class="justify-content-center" v-if="!loading">
                        <b-col cols="12" lg="10" class="mt-2">
                            <div class="text-center">
                                <p class="h4">
                                    ¡Compra confirmada!
                                </p>
                                <div class="d-flex justify-content-center">
                                    <p class="mr-2 mt-1">
                                        {{ $t("gracias.n_pedido") }}:
                                    </p>
                                    <h4 id="n-pedido">
                                        {{ n_pedido }}
                                    </h4>
                                </div>
                            </div>
                            <div class="text-center mb-3">
                                <a 
                                    :href="resumen.url_pdf"
                                    class="button large-button effect-button mr-lg-2 mb-2"
                                    target="_blank"
                                >
                                    <span style="text-transform: uppercase">
                                        {{ $t('parcelas.descargar_parcelas') }}
                                    </span>
                                </a>
                                <router-link 
                                    tag="a" 
                                    :to="{ name: 'front.home' }"
                                    class="button large-button effect-button mr-lg-2 mb-2"
                                >
                                    <span>{{ $t("gracias.volver") }}</span>
                                </router-link>
                            </div>
                            <div class="h4 mb-3">
                                Fecha: {{ resumen.fecha_compra }}
                            </div>
                            <div>
                                <DatosParcelas 
                                    v-for="(parcela, index) in resumen.parcelas"
                                    :key="index"
                                    :parcela="parcela"
                                    :index="index"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </ContentOrLoading>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import FirstBanner from "@/components/frontend/shared/FirstBanner";
    import DatosParcelas from "@/components/frontend/parcelas/DatosParcelas";

    export default {
        props: {
            session_id: {
                type: String,
                required: true
            },
            n_pedido: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                resumen: null,
                loading: false
            }
        },
        methods: {
            getResumen() {
                this.loading = true;

                const params = {
                    filters: {},
                    session_id: this.session_id,
                    n_pedido: this.n_pedido
                }

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.resumen'), params).then(res => {
                    this.resumen = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        created() {
            this.getResumen();
        },
        components: {
            PageTitle, FirstBanner, DatosParcelas
        }
    }
</script>